export default __webpack_public_path__ + "static/media/virtual-bg9.b679a952.png";